import React from 'react';
import { cx } from '@emotion/css';

import { ImageComponent } from '../Components';
type ObjectFit = 'contain' | 'cover' | 'fill' | 'none' | 'scale-down' | 'unset';

type ServiceItemProps = {
  imgSrc: string;
  imgAlt: string;
  title: string;
  description: string;
  styles: any;
  imgObjectFit?: ObjectFit;
};
export const ServiceItem = (props: ServiceItemProps) => {
  const {
    imgSrc,
    imgAlt,
    title,
    description,
    styles,
    imgObjectFit = 'fill',
  } = props;
  return (
    <div className={cx(styles.service_item, styles.root)}>
      <div className={styles.service_item_img}>
        <ImageComponent
          src={imgSrc}
          alt={imgAlt}
          objectFitvalue={imgObjectFit}
          className={styles.service_image}
        />
      </div>
      <div className={styles.service_content}>
        <h5 className={cx(styles.service_content_heading, styles.h5)}>
          {title}
        </h5>
        <p className={cx(styles.service_content_text, styles.p)}>
          {description}
        </p>
      </div>
    </div>
  );
};
